export default __webpack_public_path__ + "static/media/SF-Pro-Rounded-Light.a0f92f83.otf";